
import { groupBy } from 'lodash';

function rowGroup(resources, column_name) {
  let new_resources = []

  if (resources) {
    let index = 0
    Object.entries(groupBy(resources, column_name)).forEach(
      ([groupKey, group]) => {
        new_resources.push({
          index: index++,
          column_name: groupKey,
          _showChildren: true,
          children: group.map((item) => {
            return { ...item, index: index++ };
          })
        })
      }
    )
  }
  return new_resources;
};

function handleSpan(row, columnIndex, rowSpan) {
  if (columnIndex === 0 && row.children) {
    return [1, rowSpan.length]
  } else if (columnIndex > 0 && row.children) {
    return [0, 0]
  } else {
    return [1, 1]
  }
};

export default {
  rowGroup,
  handleSpan
};